'use client'

import dynamic from 'next/dynamic'
import Link from 'next/link'
import { Box, Typography } from '@mui/material'

// Types
import type { RelatedCardProps } from '@/types/components/molecules/solution'

// Components
const MenuItemIconAtom = dynamic(() => import('@/components/atoms/icon/menu-item'))
const ArrowRightIconAtom = dynamic(() => import('@/components/atoms/icon/bulk/arrow-right'))

// Link card to another solution page
const RelatedCardMolecule = (props: RelatedCardProps) => {
	// Props
	const { icon, title, href } = props

	return (
		<Box
			component={Link}
			href={href}
			sx={{
				height: 1,
				display: 'flex',
				alignItems: 'center',
				gap: 2,
				p: 3,
				borderRadius: 4,
				bgcolor: 'common.white',
				color: 'text.primary',
				textDecoration: 'none',
				transition: 'transform .3s, box-shadow .3s',
				'&:hover': { transform: 'translateY(-4px)', boxShadow: '0 20px 40px -20px rgba(23, 23, 23, 0.25)' },
				'&:hover .related-arrow': { color: 'secondary.main', translate: t => (t.direction === 'rtl' ? '-4px 0' : '4px 0') },
				'& .MuiSvgIcon-root': { fontSize: 24 }
			}}
		>
			<Box sx={{ color: 'primary.main', display: 'flex' }}>
				<MenuItemIconAtom name={icon} />
			</Box>

			<Typography sx={{ flexGrow: 1, fontSize: 16, fontWeight: 500 }}>{title}</Typography>

			<Box
				className="related-arrow"
				sx={{ display: 'flex', color: 'grey.400', transition: 'translate .3s, color .3s', transform: t => (t.direction === 'rtl' ? 'scaleX(-1)' : 'none') }}
			>
				<ArrowRightIconAtom />
			</Box>
		</Box>
	)
}

export default RelatedCardMolecule
